import { render, staticRenderFns } from "./JianWeiRedirect.vue?vue&type=template&id=194a06e4&scoped=true"
import script from "./JianWeiRedirect.vue?vue&type=script&lang=js"
export * from "./JianWeiRedirect.vue?vue&type=script&lang=js"
import style0 from "./JianWeiRedirect.vue?vue&type=style&index=0&id=194a06e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a06e4",
  null
  
)

export default component.exports